/* eslint-disable import/prefer-default-export */
import MWalletIdentity from './MWalletIdentity.vue';
import MWalletIdentityNoTimeout from './MWalletIdentityNoTimeout.vue';

export interface ExportedWidgetMetadata {
  /** External facing component name in Pascal case */
  componentNamePascal: string;
  constructor: any;
  /** External facing `data-widget` value in Kebab case */
  dataWidget: string;
}

interface ExportedWidgetMetadataMap {
  [key: string]: ExportedWidgetMetadata
}

/** Widgets accessible through the `data-widget` prop */
export const Widgets: ExportedWidgetMetadataMap = {
  identity: {
    componentNamePascal: 'MWalletIdentity',
    constructor: MWalletIdentity,
    dataWidget: 'm-wallet-identity'
  },
  identityNoTimeout: {
    componentNamePascal: 'MWalletIdentityNoTimeout',
    constructor: MWalletIdentityNoTimeout,
    dataWidget: 'm-wallet-identity-no-timeout'
  }
} as const; // necessary to extract types from this

export type ReplacedElementType = keyof typeof Widgets;

export interface ReplacedElement {
  el: Element;
  type: ReplacedElementType;
}

export type ComponentName = typeof Widgets[ReplacedElementType]['componentNamePascal']
